import script from "./ChatsPreviewContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ChatsPreviewContainer.vue?vue&type=script&setup=true&lang=ts"

import "./ChatsPreviewContainer.vue?vue&type=style&index=0&id=402ea361&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-402ea361"]])

export default __exports__